import { Molecule } from 'openchemlib/full';
import { isEmptyMolecule } from './isEmptyMolecule';
export function isMolfileNotEmpty(molFile) {
    if (!molFile?.match(/V[23]0/))
        return false;
    return !isEmptyMolecule(Molecule.fromMolfile(molFile));
}
//# sourceMappingURL=isMolfileNotEmpty.js.map